<template>
  <div class="boolean-expression-filter-editor">
    <div class="ref-select">
      <ExpressionEditor
        v-model="expression"
        v-bind="subObjectBinds" />
    </div>
  </div>
</template>

<script>

  import ObjectEditorMixin from '@/components/reports/config/common/ObjectEditorMixin'
  import { mapChildren } from '@/components/reports/config/common/objectUtil'

  export default {
    name: 'BooleanExpressionFilterEditor',
    mixins: [
      ObjectEditorMixin,
    ],
    computed: {
      ...mapChildren({
        expression: 'expression',
      }),
    },
  }
</script>

<style lang="scss" scoped>
.boolean-expression-filter-editor {
  display: flex;
  flex-direction: column;
}
.ref-select {
  display: flex;
  flex-direction: row;
}
</style>
